import { useNavigate } from "react-router-dom";
import { useContextSite } from "../../../context/Context";
import { IClienteForm } from "../../../types/cliente";
import { Cliente } from "../../../services/Cliente";
import { toast } from "react-toastify";
import { removerCaracteresEspeciais } from "../../../utils/masks";

export const useClientRegister = () => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();

  function handleForm(data: IClienteForm) {
    setIsLoad(true);

    const PAYLOAD: IClienteForm = {
      ...data,
      cpfCnpj: removerCaracteresEspeciais(data.cpfCnpj),
    };

    Cliente.post(PAYLOAD)
      .then(() => {
        toast.success("Cliente cadastrado com sucesso");
        setTimeout(() => {
          navigate("/configuracoes/clientes");
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  return { handleForm };
};
